const limitValueLength = (maxLength: number) => (value: string) =>
  value.slice(0, maxLength);

export default limitValueLength;
